<div class="search-container">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>{{ config?.placeholder || 'Search' }}</mat-label>
    <input 
      matInput 
      #searchInput
      [value]="searchValue"
      (input)="onSearchInput($event)"
      [placeholder]="config?.placeholder || 'Search...'">
    <button 
      mat-icon-button 
      matSuffix 
      *ngIf="searchValue"
      (click)="clearSearch(searchInput)"
      matTooltip="Clear search">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!searchValue">search</mat-icon>
  </mat-form-field>
</div>
